import { useMemo, useState } from "react";

import PropTypes from "prop-types";
import { Popover } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useTranslation } from "react-i18next";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import PlanetInfopPop from "components/LH/HC/Chart/PlanetInfopPop";

function UpaGrahaPopoverCell({ upaGraha, planetData, bhavaIndex }) {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);

    const matchedPlanet = useMemo(() => {
        if (!upaGraha || !Array.isArray(planetData)) {
            return null;
        }

        return planetData.find((item) => String(item.planet || "").trim() === String(upaGraha).trim()) || null;
    }, [planetData, upaGraha]);

    const popoverData = matchedPlanet ? [
        // { name: t("PLANET"), value: matchedPlanet.planet },
        { name: t("Place"), value: matchedPlanet.place },
        { name: t("Nekatha"), value: matchedPlanet.nekathaAdhipathi },
        { name: t("UpaGraha"), value: matchedPlanet.upaGraha },
        { name: t("BhavaPlanetAspectsCol4"), value: matchedPlanet.nakAdipathiThenpathBhavaya || '-' },
        { name: t("BhavaPlanetAspectsCol5"), value: matchedPlanet.thenpathBhavaya || '-' },
        { name: t("BhavaPlanetAspectsCol6"), value: matchedPlanet.nakAdipathiAithiBhavaya || '-' },
        { name: t("BhavaPlanetAspectsCol7"), value: matchedPlanet.aithiBhavaya || '-' },
    ] : [];

    const open = Boolean(anchorEl);

    return (
        <>
            <MDBox
                component="div"
                display="flex"
                alignItems="center"
                gap={0.5}
                minHeight="100%"
                width="100%"
                onMouseEnter={(event) => setAnchorEl(event.currentTarget)}
                onMouseLeave={() => setAnchorEl(null)}
                sx={{ cursor: matchedPlanet ? "pointer" : "default" }}
            >
                <MDTypography variant="inherit" fontWeight="medium" color="inherit">
                    {upaGraha || "-"}
                </MDTypography>
                {matchedPlanet && (
                    <InfoOutlinedIcon sx={{ fontSize: 18, color: "error.main", flexShrink: 0 }} />
                )}
            </MDBox>
            <Popover
                id="upa-graha-popover"
                sx={{ pointerEvents: "none", "& .MuiPopover-paper": { maxWidth: 600 } }}
                open={open && Boolean(matchedPlanet)}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                onClose={() => setAnchorEl(null)}
                disableRestoreFocus
            >
                <PlanetInfopPop data={popoverData} title={`${matchedPlanet?.planet || String(upaGraha || "UpaGraha")}${bhavaIndex != null ? ` (${bhavaIndex} ${t("Bhavaya")} ${t("UpaGraha")})` : ""}`} />
            </Popover>
        </>
    );
}

UpaGrahaPopoverCell.propTypes = {
    upaGraha: PropTypes.any,
    planetData: PropTypes.array,
    bhavaIndex: PropTypes.any,
};

export default UpaGrahaPopoverCell;